module.exports = __webpack_public_path__ + "img/v5.f3448a75.jpg";